 
import { ApiEndpoint, RequestBody, ResponseBody } from './BridgeProxy.Types';
import { DateUtils } from 'core/utils';
import * as UserActivityRegistry from './UserActivityRegistry';
import { Log } from 'core/infrastructure';


// Esto es necesario porque no puedo referenciar ./Electron.ts ya que él depende BridgeProxy
// y daría lugar a una dependencia circular
type ElectronType = typeof import('../../../../desktop-pos/src/preload-core');
const Electron: ElectronType = (window as any).electron;


export async function invoke<TRequestBody extends void, TResponseBody>(mode: 'NO_REGISTER_USER_ACTIVITY' | 'REGISTER_USER_ACTIVITY', endpoint: ApiEndpoint<TRequestBody, TResponseBody>): Promise<ResponseBody<typeof endpoint>>;
export async function invoke<TRequestBody, TResponseBody>(mode: 'NO_REGISTER_USER_ACTIVITY' | 'REGISTER_USER_ACTIVITY', endpoint: ApiEndpoint<TRequestBody, TResponseBody>, request: RequestBody<typeof endpoint>): Promise<ResponseBody<typeof endpoint>>;
export async function invoke<TRequestBody, TResponseBody>(mode: 'NO_REGISTER_USER_ACTIVITY' | 'REGISTER_USER_ACTIVITY', endpoint: ApiEndpoint<TRequestBody, TResponseBody>, request?: RequestBody<typeof endpoint>): Promise<ResponseBody<typeof endpoint>> {

	const invokePromise = async () => {
		Log.debug(`Bridge.invoke (${mode}) on ${endpoint.url}. Body: ${request ? JSON.stringify(request) : ''} `);
		const textResponse = await Electron.Bridge.invoke(endpoint.url, request && JSON.stringify(request));
		Log.debug(`Bridge.response from ${endpoint.url}: ${textResponse}`);
		return JSON.parse(textResponse, dateReviver);
	};

	return mode === 'NO_REGISTER_USER_ACTIVITY' ? await invokePromise() : await UserActivityRegistry.registerWhile(invokePromise);
}

// eslint-disable-next-line no-useless-escape
const DATE_RESPONSE_REGEXP = new RegExp(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([\+|-]\d{2}:\d{2})?$/);
function dateReviver(_key: string, value: any) {
	if (typeof value === 'string' && value.match(DATE_RESPONSE_REGEXP)) {
		return DateUtils.parseDate(value);
	}

	return value;
}
